import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { CASHIER_CUSTOM_EVENTS, CASHIER_ORDER_FLOW_TYPES, CASHIER_STORAGE_KEYS, CUSTOMER_TAGS, DEFAULT_SPICE_LEVEL_VALUE, ITEM_TYPES, LOADER_TIMEOUT_TIME, PHONE_NO_LENGTH, SOCKET_CLIENT_EVENTS, SOCKET_EVENTS, SWAL_SETTINGS } from '../../../../../utils/Constants';
import { TrimText, getColorType, getLocalKey, handleServerValidations, showPrice, getTranslatedKey, getUniqueID } from '../../../../../utils/commonfunction';
import { menuList, detail, categoryDetail, updateCustomerInfo, addNewMenuItem, spiceLevelsOptions, subCategoryList, menuItemDetails } from "../../../services/table.services";
import GridLoader from '../../../../restaurant/shared/gridLoader';
import RecordNotFound from '../../../../restaurant/shared/recordNotFound';
import { useFormik } from 'formik';
import CustomError from '../../../../../utils/customError';
import Swal from "sweetalert2";
import * as Yup from 'yup';
import PhoneInput from '../../../../../utils/PhoneInput';
import { Button, Modal } from 'rsuite';
import { SOCKET_CLIENT } from '../../../../../utils/socket';
import { transactionDetail } from "../../../services/sales.service";
import { buildSetMenuAddons, calculateSetMenuPrice } from '../../../utils/setMenuAddons';
import { selectGuestCountFor } from '../../../../../redux/slices/guestCount';
// Both dialogs are the qr diner's components mounted into a SweetAlert — one
// picker for both screens, so neither can fall behind the other again.
import { openSetMenuPicker, openSpicePicker } from '../../../components/setMenuPickerDialog';
import { rowsToSetSelections } from '../../../utils/setPickerRows';

export default function CashierMenu() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Carries tax_when_register_product — the rounding mode the set-menu line tax
  // is extracted with, so the picker total matches what the backend bills.
  const restSettingDetails = useSelector((state) => state?.restSettings?.data);

  const params = useParams();
  const guestCount = useSelector(selectGuestCountFor(params.tableId));
  const [menuItemList, setMenuItemList] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [loader, setLoader] = useState(true);
  const [tableDetail, setTableDetail] = useState({});
  const [combinedOrderItems, setCombinedOrderItems] = useState([])
  const [category, setCategory] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [numberOfPersonOptions, setNumberOfPersonOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const cashierData = getLocalKey('cashierDetail') ? JSON.parse(getLocalKey('cashierDetail')) : {};
  const [langChanged, setLangChanged] = useState(false);

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const orderType = location.state?.type ? location.state?.type : searchParams.get("type");
  const [transactionData, setTransactionData] = useState({});
  const { transactionId } = useParams();
  const [optionsData, setOptionsData] = useState([]);
  const [spiceOptionsLoaded, setSpiceOptionsLoaded] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);


  // console.log(params.tableId , "this is table id");

  const getTableDetail = (tableId) => {
    detail({ o_id: tableId })
      .then((response) => {
        setTableDetail(response?.data);
        let i = 1;
        const numberOfPersonOptionsTemp = [];
        for (i; i <= response?.data?.capacity; i++) {
          numberOfPersonOptionsTemp.push(i);
        }
        setNumberOfPersonOptions(numberOfPersonOptionsTemp);
        const orderData = response?.data?.activeOrder || null;
        setOrderDetail(orderData);

        if (!orderData) {
          setCombinedOrderItems([]);
          setCustomerInfo(null);
          return;
        }

        if (response?.data?.is_available === false) {
          const combinedOrderedItems = [...(orderData?.ordered_items || [])];
          orderData?.subOrders?.forEach(subOrder => {
            combinedOrderedItems.push(...subOrder.ordered_items);
          });
          setCombinedOrderItems(combinedOrderedItems);
          let customerDetails = {
            customer_name: orderData?.customer_name || '',
            customer_phone_number: orderData?.customerDetails?.customer_phone_number || '',
            number_of_persons: orderData?.number_of_persons || '',
            customer_tag: orderData?.tag || '',
          }
          setCustomerInfo(customerDetails)

        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const getTransactionDetail = (o_id) => {
    transactionDetail({ o_id: o_id })
      .then((response) => {
        setTransactionData(response && response.data ? response.data : []);
        setTableDetail(response && response.data && response?.data?.tableDetail ? response?.data?.tableDetail : null);
        let i = 1;
        const numberOfPersonOptionsTemp = [];
        for (i; i <= response?.data?.capacity; i++) {
          numberOfPersonOptionsTemp.push(i);
        }
        setNumberOfPersonOptions(numberOfPersonOptionsTemp);

        const orderData = response?.data?.orderDetail ? response?.data?.orderDetail : null
        setOrderDetail(orderData)
        const combinedOrderedItems = [...(orderData?.ordered_items || [])];
        orderData?.subOrders?.forEach(subOrder => {
          combinedOrderedItems.push(...subOrder.ordered_items);
        });
        setCombinedOrderItems(combinedOrderedItems);
        if (orderData) {
          let customerDetails = {
            customer_name: orderData?.customer_name || '',
            customer_phone_number: orderData?.customerDetails?.customer_phone_number || '',
            number_of_persons: orderData?.number_of_persons || '',
            customer_tag: orderData?.tag || '',
          }
          setCustomerInfo(customerDetails);
        }
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  };


  const getCategoryDetail = (categoryId) => {
    categoryDetail({ o_id: categoryId })
      .then((response) => {
        setCategory(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (!params.tableId || !params.category) {
      navigate('/cashier/dashboard')
    }
  }, [params.tableId, params.category, navigate]);

  useEffect(() => {
    if (params.category) {
      getCategoryDetail(params.category);
    }
  }, [params.category, langChanged]);

  useEffect(() => {
    if (!params.tableId || !params.category) return;

    if (orderType && orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_SALES) {
      getTransactionDetail(params.tableId);
    }
    if (orderType && orderType === CASHIER_ORDER_FLOW_TYPES.NEW_ORDER) {
      getTableDetail(params.tableId);
    }
    if (
      orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER ||
      orderType === CASHIER_ORDER_FLOW_TYPES.SPLIT_PAY
    ) {
      getTableDetail(params.tableId);
    }
  }, [params.tableId, params.category, orderType, langChanged, isEditing, refreshList]);



  useEffect(() => {
    if (params.category) {
      subCategoryList({ category_id: params.category }).then((res) => {
        setSubCategories(res?.data || []);
      }).catch(() => setSubCategories([]));
    }
    setSelectedSubCategory(null);
  }, [params.category]);

  useEffect(() => {
    setLoader(true);
    let formData = {};
    if (params.category) formData.category_id = params.category;
    if (selectedSubCategory) formData.sub_category_id = selectedSubCategory;
    menuList(formData)
      .then((data) => {
        if (data && data.data) {
          setMenuItemList(data.data.list || []);
        } else {
          setMenuItemList([]);
        }
        setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.error("error ====> ", error);
        setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      });
  }, [params.category, langChanged, selectedSubCategory]);

  const isItemSelected = (itemId) => {
    const exists = combinedOrderItems.some(item => item._id === itemId);
    return exists
  };



  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const getLabelByValue = (value) => {
    const item = CUSTOMER_TAGS[value.toUpperCase()];
    // console.log(item)
    return item ? CUSTOMER_TAGS[item.toUpperCase()] : '';
  };

  const customerForm = useFormik({
    initialValues: {
      order_id: orderDetail?._id,
      cashier_id: cashierData?._id,
      customer_name: orderDetail?.customer_name || '',
      customer_phone_number: orderDetail?.customerDetails?.customer_phone_number || '',
      number_of_persons: orderDetail?.number_of_persons || '',
      tag: orderDetail?.tag || CUSTOMER_TAGS.REGULAR,
      customer_note: orderDetail?.customer_note || '',
    },
    validationSchema: Yup.object({
      // name and phone are optional; validate format only when a value is entered.
      customer_name: Yup.string().trim().max(100, "max_length_error"),
      number_of_persons: Yup.string().trim().required("err_no_of_person"),
      customer_phone_number: Yup.string()
        .test('phone_digit_error', 'label_phone_number_digits_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || /^\d+$/.test(phoneNumber);
        }
        )
        .test('phone_min_length', 'label_phone_number_min_length_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || phoneNumber.length >= PHONE_NO_LENGTH.min;
        }
        )
        .test('phone_max_length', 'label_phone_number_max_length_error', (value) => {
          const phoneNumber = value ? (value.split(" "))[1] : null;
          return !phoneNumber || phoneNumber.length <= PHONE_NO_LENGTH.max;
        }
        ),
    }),
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setFieldValue }) => {
      updateCustomerInfo(values)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setIsEditing(false)
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          console.error("Error updating profile", error);
        });
    },
  });

  useEffect(() => {
    const handleLanguageChange = () => {
      setLangChanged((prev) => !prev);
    };

    document.addEventListener('language_change', handleLanguageChange);

    return () => {
      document.removeEventListener('language_change', handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    const handleSocketData = (response) => {
      if (response.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
        if (params.category) {
          getCategoryDetail(params.category)
        }
      }
      // WRDS-846: grey the item out live when an admin/staff toggles it sold-out
      // in another session. Patch just the affected item's flag in place.
      if (response.event === SOCKET_EVENTS.MENU_ITEM_AVAILABILITY_CHANGED) {
        setMenuItemList((prev) =>
          prev.map((it) =>
            it?._id === response?.data?.item_id
              ? { ...it, is_available: response.data.is_available }
              : it
          )
        );
      }
    };

    SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);

    return () => {
      SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);
    };
  }, [params.category]);

  const loadSpiceLevelOptions = async () => {
    if (spiceOptionsLoaded) return optionsData;

    try {
      const response = await spiceLevelsOptions({});
      const list = response?.data?.list || [];
      setOptionsData(list);
      setSpiceOptionsLoaded(true);
      return list;
    } catch (err) {
      console.error(err);
      return [];
    }
  };


  // Build the order line and submit. For a set menu, send one addon per choice
  // group carrying the cashier's chosen item + spice, priced as the combo (base
  // set price + chosen component prices) so a premium component is not
  // undercharged.
  const submitMenuItem = (item, { isSetItem, groups, selectionsByIndex, defaultSpiceLevel }) => {
    item.quantity = 1;

    if (item.spice_level_needed) {
      item.spice_level = defaultSpiceLevel;
    }

    if (isSetItem) {
      item.addons = buildSetMenuAddons(groups, selectionsByIndex, defaultSpiceLevel);
      // Only a set that HAD groups to choose from can fail to produce any — and
      // that is the case the guard is for. A set configured with no groups (and
      // none added from the "+") is a valid bare line, not a failed selection.
      if (groups.length && !item.addons.length) {
        return;
      }
      const priced = calculateSetMenuPrice(item, item.addons, restSettingDetails?.tax_when_register_product);
      item.price = priced.price;
      item.tax_price = priced.tax_price;
      item.total_price = priced.total_price;
    }

    let data = {
      item: item,
      table_id: orderType !== CASHIER_ORDER_FLOW_TYPES.EDIT_SALES ? params.tableId : undefined,
      type: orderType && orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER ? CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER : orderType,
      transaction_id: orderType && orderType === CASHIER_ORDER_FLOW_TYPES.EDIT_SALES ? params.tableId : undefined
    }
    const isValidOrder = localStorage.getItem(CASHIER_STORAGE_KEYS.IS_VALID_ORDER) === 'true';
    if (isValidOrder && data.type === CASHIER_ORDER_FLOW_TYPES.NEW_ORDER) {
      data.type = CASHIER_ORDER_FLOW_TYPES.EDIT_ORDER;
    }

    if (data.type === CASHIER_ORDER_FLOW_TYPES.NEW_ORDER && guestCount) {
      data.number_of_persons = guestCount;
    }
    data.item.temp_item_id = getUniqueID('selected-item-')
    addNewMenuItem(data).then((response) => {
      setRefreshList((prev) => !prev);
      const evt = new CustomEvent(CASHIER_CUSTOM_EVENTS.ITEM_ADDED);
      document.dispatchEvent(evt);
      if (response.success) {
        Swal.fire({
          icon: "success",
          text: response.message,
          ...SWAL_SETTINGS,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(response),
          ...SWAL_SETTINGS,
        });
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  // spice / set-menu items must reopen the picker on every add, each unit is a
  // distinct configuration, so a line already on the order can't hide the add
  // button (that blocked adding a second, differently-configured one).
  const needsPicker = (item) => item.type === ITEM_TYPES.SET_OF_ITEMS || item.spice_level_needed;

  const addItem = async (item) => {
    const isSetItem = item.type === ITEM_TYPES.SET_OF_ITEMS;

    // Set items need spice options (a chosen component may need one) plus the
    // resolved choice groups; a single spice item just needs the options.
    const shouldLoadSpiceOptions = item.spice_level_needed || isSetItem;
    const spiceOptions = shouldLoadSpiceOptions ? await loadSpiceLevelOptions() : optionsData;
    const defaultSpiceLevel = spiceOptions[0] || DEFAULT_SPICE_LEVEL_VALUE;

    const confirmDialogBase = {
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#f8821b",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("true_label_yes"),
      cancelButtonText: t("false_label_no"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    };

    // Set menu: resolve the choice groups, then let the cashier pick one item
    // per group (plus spice where the chosen item needs it).
    if (isSetItem) {
      let groups = [];
      let detailItem = { ...item };
      try {
        const detailRes = await menuItemDetails({ o_id: item._id });
        groups = detailRes?.data?.addons || [];
        // Prefer the detail endpoint's authoritative base price and tax rate for
        // the combo. Fall back to the list item if the fetch returned nothing.
        if (detailRes?.data) {
          detailItem = { ...item, ...detailRes.data };
        }
      } catch (err) {
        console.error(err);
      }
      const rows = await openSetMenuPicker({
        item: detailItem,
        // The item's OWN configured groups, already priced by the detail call.
        // Being the configured list, it decides which sections the picker shows
        // at all — the order path accepts no other group, so nothing else is
        // ever offered.
        groups,
        spiceOptions,
        taxRoundType: restSettingDetails?.tax_when_register_product,
        incompleteMessage: t("select_item_text"),
        soldOutMessage: t("sold_out"),
        swalOptions: {
          ...confirmDialogBase,
          // No "are you sure" and no question mark: the picker is not a confirm,
          // it is the form for choosing the set's components. Backing out of a
          // form is "Cancel", not "No" — there is no question to answer.
          icon: undefined,
          cancelButtonText: t("btn_cancel"),
          // Wider than the plain confirms this base serves: the option rows
          // carry a name, a price and a stepper side by side, and the default
          // 32rem squeezes the name down to a few characters. Takes the width
          // the terminal has — capped so it stops short of edge-to-edge on a
          // desk monitor, and `vw` so a narrow till does not overflow it.
          width: "min(66rem, 94vw)",
          // `.swal-restaurant` caps every dialog at 435px, which is what
          // actually decides the width — the `width` above is inert without
          // this. The picker opts out of that cap; nothing else does.
          customClass: {
            ...confirmDialogBase.customClass,
            popup: "swal-restaurant swal-set-picker",
            // The confirm here ADDS the line — brand fill, not the destructive
            // red the plain confirms this base serves use.
            confirmButton: "btn btn-primary col",
          },
        },
      });
      if (rows) {
        // The picker's rows carry the same facts the builder wants, arranged
        // differently — one projection, no second payload assembler.
        const selections = rowsToSetSelections(rows, groups);
        submitMenuItem(detailItem, {
          isSetItem,
          groups: selections.groups,
          selectionsByIndex: selections.selectionsByIndex,
          defaultSpiceLevel,
        });
      }
      return;
    }

    // Single spice item: the same chips, head and "Add : ¥N" confirm the set
    // picker uses — one screen for one question.
    // With no level configured there is nothing to pick: the dialog would open
    // an empty chip row over a confirm that can never enable. The item falls
    // through to the plain confirm and carries `defaultSpiceLevel`, which is
    // what it carried before this screen asked at all.
    if (item.spice_level_needed && spiceOptions.length > 0) {
      const chosenSpice = await openSpicePicker({
        item,
        spiceOptions,
        incompleteMessage: t("spice_level_text"),
        swalOptions: {
          ...confirmDialogBase,
          // Not a confirm but the form for adding the item, so no "are you
          // sure", no question mark and "Cancel" rather than "No".
          icon: undefined,
          cancelButtonText: t("btn_cancel"),
          customClass: {
            ...confirmDialogBase.customClass,
            confirmButton: "btn btn-primary col",
          },
        },
      });
      if (chosenSpice) {
        submitMenuItem(item, { isSetItem, defaultSpiceLevel: chosenSpice });
      }
      return;
    }

    // Non-set item, no spice: plain confirm.
    const result = await Swal.fire({
      ...confirmDialogBase,
      title: t("msg_are_you_sure"),
      text: t("add_menu_item"),
    });
    if (result.isConfirmed) {
      submitMenuItem(item, { isSetItem, defaultSpiceLevel });
    }
  }

  useEffect(() => {
    const handleItemAdded = () => {
      setRefreshList((prev) => !prev);
    };

    document.addEventListener(CASHIER_CUSTOM_EVENTS.ITEM_DELETED, handleItemAdded);


    return () => {
      document.removeEventListener(CASHIER_CUSTOM_EVENTS.ITEM_DELETED, handleItemAdded);
    };
  }, []);

  return (
    <>

      <div className='dashboard-cashier-left d-flex flex-column'>
        <div className='cashier-head text-center'>
          <div className='btns-head-in-left gap-2 d-flex'>
            <button className='btn btn-icon' onClick={() => {
              // if (tableDetail && tableDetail.activeOrder) {
              //   // clear current route state before going back
              //   console.log('state cleared')
              //   // navigate('.', { replace: true, state: null });
              // }

              navigate(-1);
            }}>
              <i className='ti ti-arrow-left'></i>
            </button>
          </div>
          <h4>{TrimText(tableDetail.table_number, 20)}</h4>
          <div className='btns-head-in gap-2 d-flex'>
            <button className='btn btn-icon' onClick={() => setIsOpen(true)}>
              <i className='ti ti-user'></i>
            </button>
            <button className='btn btn-icon'>
              <i className='ti ti-printer'></i>
            </button>
          </div>
        </div>


        <div className='cashier-category-wrap'>
          <h4 className='mb-3'>{TrimText(getTranslatedKey('name', category), 20)}</h4>
          {subCategories.length > 0 && (
            <div className='category-list-grid mb-3'>
              {subCategories.map((sub, index) => (
                <div
                  key={index}
                  className={selectedSubCategory === sub._id ? 'btn btn-primary btn-total w-100 d-flex justify-content-center mt-0' : 'keypad-action-btns w-100 justify-content-center mt-0'}
                  style={selectedSubCategory === sub._id ? { cursor: 'pointer', padding: '9px 12px', fontSize: '11px', width: '50%' } : { cursor: 'pointer', height: '48px', padding: '12px', fontSize: '12px', width: '50%' }}
                  onClick={() => setSelectedSubCategory(selectedSubCategory === sub._id ? null : sub._id)}
                >
                  <span>{getTranslatedKey('name', sub)}</span>
                </div>
              ))}
            </div>
          )}
          {
            loader ?
              <GridLoader />
              :
              menuItemList.length ?
                <div className='category-list-grid menu-list-grid'>
                  {menuItemList.map((item, index) => (
                    <div key={index} className={`category-box cp category-menu-box menu-actions-trigger ${isItemSelected(item?._id) ? 'item-selected' : ''} ${item?.is_available === false ? 'sold-out' : ''}`} >
                      <div className="category-name menu-img">
                        <img src={item.image} alt="" />
                        {item?.is_available === false && <span className="sold-out-badge">{t('label_sold_out')}</span>}
                      </div>
                      <div className="menu-item-info">
                        <h4>{TrimText(getTranslatedKey('item_name', item), 15)}</h4>
                        <span>¥ {showPrice(item?.total_price)}</span>

                      </div>
                     {
                      (!isItemSelected(item?._id) || needsPicker(item)) &&
                      <div className='menu-items-actions' style={{right:"unset", left:"50%", transform:"translate(-50%, -50%)"}}>
                        {item?.is_available === false
                          ? <button className='btn btn-secondary w-100' disabled><i className="ti ti-ban"></i>{t('label_sold_out')}</button>
                          : <button className='btn btn-primary w-100' disabled={localStorage.getItem(CASHIER_STORAGE_KEYS.HAS_SPLIT_PAYMENT) === 'true'} onClick={()=>addItem(item)}><i className="ti ti-plus"></i>{t('link_add')}</button>}
                      </div>
                     }
                    </div>
                  ))}

                </div>
                :
                <RecordNotFound heading="no_assigned_item_text" text="no_category_found_text_para" />
          }
        </div>

        <Modal backdrop="static" open={isOpen} className='modal-cashier'>
          <Modal.Header className="modal-header d-flex justify-content-between">
            <button type="button" className="btn btn-icon" aria-label="Close" onClick={() => isEditing ? setIsEditing(false) : setIsOpen(false)}>
              <i className="ti ti-arrow-left"></i>
            </button>
            <h1 className="modal-title fs-5">Customer info</h1>
            <button type="button" className="btn btn-icon" onClick={() => setIsOpen(false)} aria-label="Close">
              <i className="ti ti-x"></i> {/* Replace this with your custom icon if needed */}
            </button>
          </Modal.Header>
          <hr className='mb-0' />
          <Modal.Body className="modal-body mt-0">
            {!isEditing ? (
              <>
                <div className='card-list'>
                  <ul>
                    <li>
                      <h4>{t('list_heading_name')}</h4>
                      <h3>{TrimText(customerInfo?.customer_name)}</h3>
                    </li>
                    <li>
                      <h4>{t('label_phone_number')}</h4>
                      <h3>{customerInfo?.customer_phone_number}</h3>
                    </li>
                    <li>
                      <h4>{t('number_of_person_text')}</h4>
                      <h3>{customerInfo?.number_of_persons}</h3>
                    </li>
                    <li>
                      <h4>{t('label_tag')}</h4>
                      {/* {console.log(customerInfo)} */}
                      <h3>{customerInfo?.customer_tag ? t(getLabelByValue(customerInfo?.customer_tag)) : ""}</h3>
                    </li>
                    <li>
                      <h4>{t('label_special_requirement')}</h4>
                      <h3>{customerInfo?.customer_note}</h3>
                    </li>
                  </ul>
                </div>
                <Button onClick={toggleEdit} className='btn btn-primary w-100 mt-3'>
                  {t('btn_edit')}
                </Button>
              </>
            ) : (
              <form onSubmit={customerForm.handleSubmit}>
                <div className='mb-3'>
                  <label className='form-label'>{t('list_heading_name')}</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={t('placeholder_enter_addon_option_name')}
                    name="customer_name"
                    value={customerForm.values.customer_name}
                    onChange={customerForm.handleChange}
                  />
                  <CustomError name="customer_name" form={customerForm} className="text-danger" />
                </div>

                <div className='mb-3'>
                  <label className='form-label'>{t('label_phone_number')}</label>
                  <PhoneInput
                    placeholder={t('placeholder_phone_number')}
                    value={customerForm.values.customer_phone_number}
                    onChange={(e) => customerForm.setFieldValue('customer_phone_number', e?.phone_number)}
                    onBlur={customerForm.handleBlur}
                  />
                  <CustomError name="customer_phone_number" form={customerForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                </div>

                <div className='mb-3'>
                  <label className='form-label'>{t('number_of_person_text')}<span>*</span></label>
                  <select
                    className='form-control cp'
                    name='number_of_persons'
                    value={customerForm.values.number_of_persons}
                    onChange={(e) => customerForm.setFieldValue("number_of_persons", e.target.value ? Number(e.target.value) : "")}
                  >
                    <option value="">{t('input_select_text')}</option>
                    {numberOfPersonOptions.map((option, index) => (
                      <option value={option} key={index}>{option}</option>
                    ))}
                  </select>
                  <CustomError className="text-danger" name="number_of_persons" form={customerForm} />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("label_customer_tag")}</label>
                  <select
                    className="form-control cp"
                    name="tag"
                    value={customerForm.values.tag}
                    onChange={customerForm.handleChange}
                    onBlur={customerForm.handleBlur}
                  >
                    <option value="" label={t("placeholder_select_table_customer_tag")} />
                    <option value={CUSTOMER_TAGS.VIP}>{CUSTOMER_TAGS.VIP}</option>
                    <option value={CUSTOMER_TAGS.REGULAR}>{CUSTOMER_TAGS.REGULAR}</option>
                  </select>
                  <CustomError className="text-danger" name="tag" form={customerForm} />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("label_special_requirement")}</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    maxLength={200}
                    placeholder={t("placeholder_special_requirement")}
                    name="customer_note"
                    value={customerForm.values.customer_note}
                    onChange={customerForm.handleChange}
                  />
                </div>
                <Button type="submit" className="btn btn-primary w-100 mt-3" block>
                  {t('btn_save')}
                </Button>
              </form>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}




{/* <div className="modal fade modal-cashier" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div className="modal-dialog modal-dialog-centered">
  <div className="modal-content">
    <div className="modal-header d-flex justify-content-between">
      <button type="button" className="btn btn-icon" data-bs-dismiss="modal" aria-label="Close">
        <i className='ti ti-arrow-left'></i>
      </button>
      <h1 className="modal-title fs-5" id="exampleModalLabel">Customer info</h1>
      <button type="button" className="btn btn-icon" data-bs-dismiss="modal" aria-label="Close">
        <i className='ti ti-x'></i>
      </button>
    </div>
    <div className="modal-body">
      <div className='card-list'>
        <ul>
          <li>
            <h4>Name</h4>
            <h3>Lissa watson</h3>
          </li>
          <li>
            <h4>Phone number</h4>
            <h3>+81 45124 45124</h3>
          </li>
          <li>
            <h4>Number of persons </h4>
            <h3>5</h3>
          </li>
          <li>
            <h4>Tag</h4>
            <h3>VIP</h3>
          </li>
        </ul>
      </div>
      <button className='btn btn-primary w-100 mt-3'>Edit</button>
    </div>
  </div>
</div>
</div> */}
